module.exports = __webpack_public_path__ + "static/media/Safe-T7.eed24199.JPG";